import IFormModel from "@/models/IFormModel";
import {ValidationRule} from "@/declarations/ValidationRule";
import BillRules from "@/models/bill/BillRules";

export default class BillCreate implements IFormModel {

	public name: string | null = null;
	public companyId: string | null = null;
	public billingDate: string | null = null;

	public addReports: boolean = false;
	public addReportsRangeFrom: string | null = null;
	public addReportsRangeTo: string | null = null;

	public reset(): void {
		this.name = null;
		this.companyId = null;
		this.billingDate = null;
		this.addReports = false;
		this.addReportsRangeFrom = null;
		this.addReportsRangeTo = null;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'name':
				return BillRules.nameRules;
			case 'companyId':
				return BillRules.companyIdRules;
			case 'billingDate':
				return BillRules.billingDateRules;
			default:
				return [];
		}
	}

}
